import { fetchWithAuth } from '../utils/api';

export interface User {
  id: number;
  username: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  is_admin?: boolean;
  is_debater?: boolean;
  is_adjudicator?: boolean;
}

// Define interfaces for the log structure received from the API
interface LogUser {
  id: number;
  username: string;
  first_name?: string;
  last_name?: string;
}

interface Log {
  id: number;
  user: LogUser;
  // Other properties not needed for this function
}

interface LogDateGroup {
  date: string;
  logs: Log[];
}

export const fetchUsers = async (): Promise<User[]> => {
  try {
    // Use the logs attendance endpoint instead of a dedicated users endpoint
    // This matches the old build's approach
    const response = await fetchWithAuth('/api/admin/logs/attendance/');
    
    // Extract unique users from the logs
    if (Array.isArray(response) && response.length > 0) {
      const uniqueUsers = new Map<number, User>();
      
      // Process each date group
      response.forEach((dateGroup: LogDateGroup) => {
        if (dateGroup && Array.isArray(dateGroup.logs)) {
          // Process each log in the date group
          dateGroup.logs.forEach((log: Log) => {
            if (log && log.user && log.user.id) {
              uniqueUsers.set(log.user.id, {
                id: log.user.id,
                username: log.user.username,
                first_name: log.user.first_name,
                last_name: log.user.last_name
              });
            }
          });
        }
      });
      
      // Convert Map values to array
      return Array.from(uniqueUsers.values());
    }
    
    return [];
  } catch (error) {
    console.error("Error fetching users:", error);
    return [];
  }
};

export const fetchUser = async (userId: number): Promise<User | null> => {
  try {
    const response = await fetchWithAuth(`/api/users/${userId}/`);
    return response || null;
  } catch (error) {
    console.error(`Error fetching user ${userId}:`, error);
    return null;
  }
}; 